import { render, staticRenderFns } from "./open-requests.vue?vue&type=template&id=5ec6f934"
import script from "./open-requests.vue?vue&type=script&lang=js"
export * from "./open-requests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports